module.exports = __webpack_public_path__ + "static/media/2025_VR_Travel.8d31f57e.pdf";